<template>
    <div class="two-tone-layout">
        <div class="equal-content-sidebar">
            <div class="container">
                <loading :active.sync="isLoading"/>
                <div v-if="!isLoading" id="sticky-sidebar" class="sidebar-wrapper ">
                    <aside>
                        <div class="mb-10 mb-5-sm"></div>
                        <right-form/>
                        <div class="mb-30 mb-5-sm"></div>
                    </aside>
                </div>
                <div class="content-wrapper">
                    <head-title/>
                    <div class="mb-10"></div>
                    <div class="detail-content-for-sticky-menu mb-50">
                        <div class="clear"></div>
                        <gallery :image1="room.images[0].imagePath" :image2="room.images[1].imagePath"/>
                    </div>
                    <div id="detail-content-sticky-nav-02" class="pt-30">
                        <div class="section-title-3 mb-40">
                            <h3>Información</h3>
                        </div>
                        <h5 class="font400 text-uppercase mb-15 font16">Sobre la sala:</h5>
                        <p>{{room.description}}</p>
                        <div class="mb-30"></div>
                        <meeting-facts/>
                        <div class="mb-30"></div>
                        <div class=" row gap-20 clearfix">
                            <meeting-services/>
                        </div>
                        <div class="bb mt-10"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import gallery from '../components/meetingRoom/gallery';
    import headTitle from '../components/meetingRoom/headTitle';
    import meetingFacts from '../components/meetingRoom/meetingFacts';
    import rightForm from '../components/meetingRoom/rightForm';
    import meetingServices from '../components/meetingRoom/meetingServices';

    export default {
        name: 'meetingRoom',
        data: function () {
            return {
                room: [],
                isLoading: true
            }
        },
        components: {headTitle, Loading, gallery, meetingFacts, meetingServices, rightForm},
        methods: {
            async getRoom(lat, lng) {
                let url = "https://roomapi.vola.cat/clients/getroom/" + this.$route.params.roomid;
                const rooms = await axios.get(url);
                this.room = rooms.data.meetingRoom;
                this.isLoading = false;
            },
        },
        mounted() {
            this.getRoom();
        }
    }
</script>